var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable array-bracket-spacing, comma-dangle, no-undef, no-unused-vars, no-var, react/jsx-closing-bracket-location, react/prop-types, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var WidgetJsonifyDeprecated = require("../mixins/widget-jsonify-deprecated.jsx");

var MAX_SIZE = 8;

// Styling
var CELL_PADDING = 5;

var TABLE_STYLE = {
    display: "table",
    tableLayout: "fixed"
};

var ROW_STYLE = {
    display: "table-row"
};

var CELL_STYLE = {
    display: "table-cell",
    padding: CELL_PADDING
};

var BASE_TILE_STYLE = {
    borderRadius: 10,
    cursor: "pointer"
};

var MOVE_COUNT_STYLE = {
    padding: CELL_PADDING,
    display: "inline-block"
};

var RESET_BUTTON_STYLE = {
    float: "right",
    paddingRight: CELL_PADDING
};

var MAIN_TILE_SIZE = 50;

var mapCells = function mapCells(cells, func) {
    return _.map(cells, function (row, y) {
        return _.map(row, function (value, x) {
            return func(value, y, x);
        });
    });
};

var genCells = function genCells(height, width, func) {
    return _.times(height, function (y) {
        return _.times(width, function (x) {
            return func(y, x);
        });
    });
};

var PATTERNS = {
    plus: function plus() {
        return [[false, true, false], [true, true, true], [false, true, false]];
    },
    x: function x() {
        return [[true, false, true], [false, true, false], [true, false, true]];
    },
    "plus/x": function plusX(iter) {
        return iter % 2 ? PATTERNS.x() : PATTERNS.plus();
    }
};

/**
 * Clamps value to an integer in the range [min, max]
 */
var clampToInt = function clampToInt(value, min, max) {
    value = Math.floor(value);
    value = Math.max(value, min);
    value = Math.min(value, max);
    return value;
};

// A single glowy cell
var Tile = React.createClass({
    displayName: "Tile",

    propTypes: {
        value: React.PropTypes.bool.isRequired,
        size: React.PropTypes.number.isRequired
    },

    render: function render() {
        var color = this.props.value ? "#55dd55" : "#115511";
        var style = _.extend({}, BASE_TILE_STYLE, {
            width: this.props.size,
            height: this.props.size,
            backgroundColor: color
        });
        return React.createElement("div", { style: style, onClick: this._flip });
    },

    _flip: function _flip() {
        this.props.onChange(!this.props.value);
    }
});

// A grid of glowy cells
var TileGrid = React.createClass({
    displayName: "TileGrid",

    propTypes: {
        cells: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.bool)).isRequired,
        size: React.PropTypes.number.isRequired
    },

    render: function render() {
        var _this = this;

        return React.createElement(
            "div",
            { style: TABLE_STYLE, className: "no-select" },
            _.map(this.props.cells, function (row, y) {
                return React.createElement(
                    "div",
                    { key: y, style: ROW_STYLE },
                    _.map(row, function (cell, x) {
                        return React.createElement(
                            "div",
                            { key: x, style: CELL_STYLE },
                            React.createElement(Tile, {
                                value: cell,
                                size: _this.props.size,
                                onChange: _.partial(_this.props.onChange, y, x)
                            })
                        );
                    })
                );
            })
        );
    }
});

// Returns a copy of the tiles, with tiles flipped according to
// whether or not their y, x position satisfies the predicate
var flipTilesPredicate = function flipTilesPredicate(oldCells, predicate) {
    return _.map(oldCells, function (row, y) {
        return _.map(row, function (cell, x) {
            return predicate(y, x) ? !cell : cell;
        });
    });
};

var flipTilesPattern = function flipTilesPattern(oldCells, tileY, tileX, pattern) {
    return flipTilesPredicate(oldCells, function (y, x) {
        var offsetY = y - tileY;
        var offsetX = x - tileX;
        if (Math.abs(offsetY) <= 1 && Math.abs(offsetX) <= 1) {
            return pattern[offsetY + 1][offsetX + 1];
        } else {
            return false;
        }
    });
};

// The lights puzzle widget
var LightsPuzzle = React.createClass({
    displayName: "LightsPuzzle",

    propTypes: _extends({}, Changeable.propTypes, {
        cells: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.bool)),
        startCells: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.bool)),
        flipPattern: React.PropTypes.string.isRequired,
        moveCount: React.PropTypes.number.isRequired
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            cells: [[false, false, false], [false, false, false], [false, false, false]],
            startCells: [[false, false, false], [false, false, false], [false, false, false]],
            flipPattern: "plus",
            moveCount: 0
        };
    },

    getUserInput: function getUserInput() {
        return WidgetJsonifyDeprecated.getUserInput.call(this);
    },

    render: function render() {
        var width = this._width();
        var tileSize = MAIN_TILE_SIZE;
        var pxWidth = width * (tileSize + 2 * CELL_PADDING);
        return React.createElement(
            "div",
            null,
            React.createElement(TileGrid, {
                cells: this.props.cells,
                size: tileSize,
                onChange: this._flipTile
            }),
            React.createElement(
                "div",
                { style: { width: pxWidth } },
                React.createElement(
                    "div",
                    { style: MOVE_COUNT_STYLE },
                    "Moves: ",
                    this.props.moveCount
                ),
                React.createElement(
                    "div",
                    { style: RESET_BUTTON_STYLE },
                    React.createElement("input", {
                        type: "button",
                        value: "Reset",
                        onClick: this._reset,
                        className: "simple-button"
                    })
                )
            ),
            React.createElement("div", { className: "clearfix" })
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    _width: function _width() {
        if (this.props.cells.length !== 0) {
            return this.props.cells[0].length;
        } else {
            return 0; // default to 0
        }
    },

    componentDidMount: function componentDidMount() {
        this._initNextPatterns();
    },

    componentDidUpdate: function componentDidUpdate(prevProps) {
        if (prevProps.flipPattern !== this.props.flipPattern) {
            this._initNextPatterns();
        }
    },

    _initNextPatterns: function _initNextPatterns() {
        this._currPattern = PATTERNS[this.props.flipPattern](0);
        this._nextPattern = PATTERNS[this.props.flipPattern](1);
        this._patternIndex = 2;
    },

    _shiftPatterns: function _shiftPatterns() {
        this._currPattern = this._nextPattern;
        this._nextPattern = PATTERNS[this.props.flipPattern](this._patternIndex);
        this._patternIndex++;
    },

    _flipTile: function _flipTile(tileY, tileX) {
        var newCells = flipTilesPattern(this.props.cells, tileY, tileX, this._currPattern);
        this._shiftPatterns();

        this.change({
            cells: newCells,
            moveCount: this.props.moveCount + 1
        });
    },

    _reset: function _reset() {
        this.change({
            cells: this.props.startCells,
            moveCount: 0
        });
    },

    simpleValidate: function simpleValidate(rubric) {
        return validate(rubric, this.getUserInput());
    }
});

// grading function
var validate = function validate(rubric, state) {
    var empty = _.all(state.cells, function (row, y) {
        return _.all(row, function (cell, x) {
            return cell === rubric.startCells[y][x];
        });
    });
    if (empty) {
        return {
            type: "invalid",
            message: i18n._("Click on the tiles to change the lights.")
        };
    }

    var correct = _.all(state.cells, function (row) {
        return _.all(row, function (cell) {
            return cell;
        });
    });

    if (correct) {
        return {
            type: "points",
            earned: 1,
            total: 1,
            message: null
        };
    } else if (rubric.gradeIncompleteAsWrong) {
        return {
            type: "points",
            earned: 0,
            total: 1,
            message: null
        };
    } else {
        return {
            type: "invalid",
            message: i18n._("You must turn on all of the lights to continue.")
        };
    }
};

// The function run on the editor props to create the widget props
var transformProps = function transformProps(editorProps) {
    return {
        cells: editorProps.startCells,
        startCells: editorProps.startCells,
        flipPattern: editorProps.flipPattern
    };
};

module.exports = {
    name: "lights-puzzle",
    displayName: "Lights Puzzle",
    hidden: true,
    widget: LightsPuzzle,
    transform: transformProps
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/lights-puzzle.jsx
 ** module id = 120
 ** module chunks = 0 1
 **/